<template>
<div class="chapter">
<div class="inner_page">
<h2 title="Cover"></h2>
<p class="center" id="cover"><img alt="Hearing God: Developing a Conversational Relationship with God Cover" src="Images/9780830869923.jpg"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// cover.vue?44638939